/* The little progress bar Lulus puts under anything that swipes - the product
   gallery and every carousel. Theirs is .c-car__scrollbar: a 2px bar on a
   #e5e5e5 track, 1px radius, the thumb #222, sized to the fraction of the row
   that is on screen and slid along as you scroll.

   Markup: <div class="hvbar" data-hvbar><span></span></div> sitting next to the
   scrolling element, which carries data-viewport. */

(function () {
  function wire(bar) {
    /* Already wired: just repaint. Tab panes measure 0 while hidden, so the
       bar has to be recalculated the moment its pane is shown. */
    if (bar.__hvPaint) {
      bar.__hvPaint();
      return;
    }

    const holder = bar.parentElement;
    if (!holder) return;
    const viewport = holder.querySelector('[data-viewport]');
    const thumb = bar.firstElementChild;
    if (!viewport || !thumb) return;

    const paint = function () {
      const sw = viewport.scrollWidth;
      const cw = viewport.clientWidth;
      /* nothing to scroll, or the pane is hidden - Lulus hides the bar rather
         than showing a full-width one */
      if (!cw || sw <= cw + 2) {
        bar.hidden = true;
        return;
      }
      bar.hidden = false;
      const ratio = cw / sw;
      const p = viewport.scrollLeft / (sw - cw);
      thumb.style.width = (ratio * 100).toFixed(3) + '%';
      thumb.style.insetInlineStart = (Math.min(Math.max(p, 0), 1) * (1 - ratio) * 100).toFixed(3) + '%';
    };

    let raf = 0;
    const schedule = function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(paint);
      /* rAF is throttled in some contexts; this makes sure it still lands */
      setTimeout(paint, 60);
    };

    bar.__hvPaint = schedule;

    viewport.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(schedule);
      ro.observe(viewport);
      if (viewport.firstElementChild) ro.observe(viewport.firstElementChild);
    }
    /* photos load late and change scrollWidth */
    viewport.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', schedule, { once: true });
    });
    paint();
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-hvbar]').forEach(wire);
  }

  window.hvScanBars = scan;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  /* rows that fill themselves in later (Recently Viewed, tab panes) */
  window.addEventListener('load', function () { scan(); });
})();
